
import _ from 'lodash'

export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Select Procedure',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        internalSearch: {
            type: Boolean,
            default: false,
        },
        clearOnSelect: {
            type: Boolean,
            default: false,
        },
        showNoOptions: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        helpText: {
            type: String,
            default: null,
        },
        searchValue: {
            type: Function,
            default: () => {}
        },
        getSelectedValue: {
            type: Function,
            default: v => v
        }
    },
    data () {
        return {
            selectableOptions: [],
            selectedValue: null,
        }
    },
    async fetch () {
        const query = this.query || ''
        if (!query || query.length < 3) {
            return
        }
        const results = await this.searchValue({ query })
        this.selectableOptions = results?.items || results?.results || results || []
    },
    watch: {
        value () {
            if (!_.isEqual(parseInt(this.value), this.selectedValue?.id)) {
                this.updateValue()
            }
        },
        selectedValue () {
            this.emitInput()
        },
    },
    mounted () {
        this.updateValue()
    },
    methods: {
        async updateValue () {
            if (this.value) {
                const selectedValue = await this.getSelectedValue(this.value)
                this.selectedValue = selectedValue
            } else {
                this.selectedValue = null
            }
        },
        emitInput () {
            this.$emit('input', this.selectedValue?.id || null)
            this.$emit('input-raw', this.selectedValue || null)
        },
        search (query) {
            this.query = query
            return this.$fetch()
        },
    },
}
